import { getOffersByStatus, updateOfferStatus } from 'apis/offers/index.js'
import { ManagementSecMainHeader, Table } from "components"
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { encodeToBase64 } from 'utils/encodeAndDecode.js'
import { OFFER } from "../../../common/routes.js"



function Index() {

    const navigate = useNavigate()
    const [offers, setOffers] = useState()
    const [status, setStatus] = useState('published')
    const [pageNation, setPageNation] = useState({
        currentPage: 1,
        nextPage: null,
        prevPage: null,
    })

    const columns = [
        {
            Header: 'No',
            accessor: (row, rowIndex) => rowIndex + 1,
            id: 'no'
        },
        { Header: 'Title', accessor: 'title' },
        { Header: 'Code', accessor: 'offer_code' },
        { Header: 'Offer %', accessor: 'offer' },
        {
            Header: 'Date',
            accessor: (data) => moment(data.start_date).format('YYYY-MM-DD')
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ row }) => (
                <>
                    {row?.original?.status === 'published' ?
                        <span onClick={() => handleUpdateStatus(row, 'draft')} className='p-2 text-green-500 bg-green-100 cursor-pointer rounded-3xl'>
                            Published
                        </span>
                        :
                        <span onClick={() => handleUpdateStatus(row, 'published')} className='p-2 text-red-500 bg-red-100 cursor-pointer rounded-3xl'>
                            Draft
                        </span>

                    }
                </>

            )
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <div>
                    <button onClick={() => handleEdit(row)} className='p-2 px-3 mr-1 text-white bg-green-500 rounded-xl'>Edit</button>
                </div>
            )
        }
    ];

    const handleBtn = async () => {
        navigate(OFFER.CREATE_OFFER)
    }

    const fetchOffersByStatus = async (page) => {
        const res = await getOffersByStatus(page, status)
        setOffers(res?.data)
        const pagination = res?.pagination
        setPageNation({ currentPage: pagination?.current_page, nextPage: pagination?.next_page, prevPage: pagination?.previous_page })
    }

    const handleUpdateStatus = async (row, value) => {
        const data = {
            status: value
        }
        const res = await updateOfferStatus(row?.original?.id, data)
        if (res?.success) fetchOffersByStatus(pageNation?.currentPage)
    }

    const handleEdit = (row) => {
        const id = encodeToBase64(row.original.id);
        const url = `${OFFER.CREATE_OFFER}?id=${id}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    };


    useEffect(() => {
        fetchOffersByStatus(1)
    }, [status])



    return (
        <div className='flex flex-col h-screen'>

            {/* Main Content Section */}
            <div className="bg-[#f8f8f8] h-screen w-full">
                {/* Header */}
                <div className="w-[96%] mx-auto my-10">
                    <ManagementSecMainHeader
                        mainHeading={"Offer"}
                        subHeading={"Manage your events effectively"}
                        btnText={"Add Offer"}
                        handleBtn={handleBtn} />
                </div>
                {/* Table */}

                <div className="p-8">
                    <div className="flex">
                        <button onClick={() => setStatus('published')} className={`p-2 px-6 border ${status === 'draft' ? '' : 'bg-gray-300'}`}>Published</button>
                        <button onClick={() => setStatus('draft')} className={`p-2 px-6 border-2 border-b-0 ${status === 'draft' ? 'bg-gray-300' : ''}`}>Draft</button>
                    </div>

                    {offers &&
                        <Table columns={columns} data={offers} pageNation={pageNation} handlePageNation={(value) => fetchAllUsers(value)} />
                    }
                </div>
            </div>
        </div>
    )
}

export default Index